import React from 'react';
import { Bar, BarChart, LabelList, Legend, ResponsiveContainer, Tooltip, XAxis, YAxis } from 'recharts';
import PropTypes from 'prop-types';
import { PAYMENT_GATEWAY } from '@/modules/payments/contants/prepaid';
import { COLOR_IMPORTE } from '@/modules/dashboard/constants/colors';
import { showValueWithCurrency } from '@/utils/utils';

// Expects data: [{ paymentMethods, count, amount }]
const BarChartPagosPorMetodo = ({ data = [] }) => {
  const hasData = data?.some(item => item.count > 0);
  
  const chartData = hasData ? data
    ?.sort((a, b) => a.paymentMethods.localeCompare(b.paymentMethods))
    ?.map(item => ({
      ...item,
      name: PAYMENT_GATEWAY[item.paymentMethods] || item.paymentMethods,
    })) :
    [{ name: 'Sin datos', amount: 0 }];
  
  return (
    <ResponsiveContainer width="100%" height={350}>
      <BarChart data={chartData} margin={{ top: 20, right: 30, left: 0, bottom: 5 }}>
        <XAxis dataKey="name" />
        <YAxis />
        {hasData && <Tooltip formatter={(value) => showValueWithCurrency(value.toLocaleString())} />}
        <Legend formatter={() => 'Importe'} />
        <Bar dataKey="amount" fill={COLOR_IMPORTE} name="Importe">
          <LabelList dataKey="amount" position="top"
            formatter={(value) => showValueWithCurrency(value.toLocaleString())} />
        </Bar>
      </BarChart>
    </ResponsiveContainer>
  );
};

BarChartPagosPorMetodo.propTypes = {
  data: PropTypes.array,
};

export default BarChartPagosPorMetodo;

